import React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { I18nContextProvider } from '@ecg-marktplaats/js-react-i18n';
import { Header } from '@hz-design-system/web-ui';

import PopularKeywordApp from '../../apps/PopularKeywordApp';

import '../../../scss/global.scss';

export default (i18n) => {
  const appState = window.__CONFIG__ || {
    keyword: '',
    searchResults: {
      subCategories: [],
      listings: [],
      lrpBaseUrl: '',
      query: '',
    },
  };
  const environment = window.__ENV_CONFIG__ || {};
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const headerRoot = document.getElementById('header-root');
  const popularKeywordRoot = document.getElementById('popular-keyword-root');

  // Header is server side rendered in express-react library
  // todo: Add I18nContext wrapper here and in express-react as well
  if (headerRoot) {
    hydrateRoot(headerRoot, <Header headerConfig={headerConfig} />);
  }

  if (popularKeywordRoot) {
    hydrateRoot(
      popularKeywordRoot,
      <I18nContextProvider i18nInstance={i18n}>
        <PopularKeywordApp appState={appState} environment={environment} />
      </I18nContextProvider>,
    );
  }
};
